import React, { Component } from 'react'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import SEO from '../../../components/seo'

import axios from 'axios'

import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'

import Layout from '../../../components/layout/layout'
import NextPreviousRow from '../../../components/next-previous'
import PageTitle from '../../../components/page-title'

import isUserSignedIn from '../../../auth/is-user-signed-in'

import StudentContent from '../../../components/layout/student-content'
import TeacherContentStudentAccordion from '../../../components/layout/teacher-content/teacher-content-student-accordion'
import TeacherContentTeacherAccordion from '../../../components/layout/teacher-content/teacher-content-teacher-accordion'
import Video from '../../../components/video'

// eslint-disable-next-line
import threedmssImage from '../../../queries/threedmssImage'

const Page = class extends Component {
  constructor(props) {
    super(props)

    this.state = {
      student_accordion_open: true,
      authenticated: undefined
    }

    this.axios_cancel_token = axios.CancelToken.source()
  }

  async componentDidMount () {
    const is_signed_in = isUserSignedIn()
    this.setState({authenticated: is_signed_in})
  }

  render() {
    const { location } = this.props
    if (this.state.authenticated === undefined) {
      return (
        <React.Fragment>
          <Layout>
            <Container fluid className="d-flex h-100 flex-column pt-3">
              <Row className="mb-3 justify-content-center w-100">
                <div className="spinner-grow text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </Row>
            </Container>
          </Layout>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <SEO title="Food in the Body: My Ideas" />
          <Layout
            location={location}
            course="threedmss"
            setStudentAccordionState={(state) => this.setState({student_accordion_open: state})}
            setAuthenticated={(is_signed_in) => this.setState({authenticated: is_signed_in})}
          >
            <Container fluid className="d-flex h-100 flex-column pt-3">
              <PageTitle title="Food in the Body: My Ideas" no_breadcrumb={true} />
              <Row style={{ marginBottom: '2rem' }}>
                {this.state.authenticated &&
                  <React.Fragment>
                    <Col xs={12} lg={6} id="student-accordion-column">
                      <TeacherContentStudentAccordion
                        title="Student View"
                        open={this.state.student_accordion_open}
                        setStudentAccordionState={() => {
                          /*
                            Anytime this is called, it's toggling so I'm just setting it to the opposite of its current state. This is to sync the student accordion state with the ToggleStudentView component.  Pretty much just don't worry about it. Keep walking.
                          */
                          if (this.state.student_accordion_open) {
                            this.setState({student_accordion_open: false})
                          } else {
                            this.setState({student_accordion_open: true})
                          }
                        }}
                      >
                        <div className="row">
                          <div className="col-12">
                            <hr className="focus-question-heading bold-me d-none d-md-block d-lg-none d-xl-block" />

                            <h3 className="bold-me d-block d-md-none d-lg-block d-xl-none text-center">Focus Question</h3>
                            <hr className="d-block d-md-none d-lg-block d-xl-none" />

                            <p className="focus-question bold-me">What happens to food in a healthy person, and how is it different for M'Kenna?</p>

                            <hr className="after-focus-question" />

                            <div className="row">
                              <div className="col-12">
                              <div className="image-wrapper-right">
                                <Img
                                  fluid={this.props.data.image1.childImageSharp.fluid}
                                  alt="Image of a student with their school lunch on a tray."
                                  className="image image-bordered"
                                />
                                <div className="image-caption image-caption-bordered">
                                  Lunch is an important meal in the day. Your body depends on getting food during the day, but why?  <br />
                                  <span className="image-credit">Courtesy Steve Debenport</span>
                                </div>
                              </div>
                                <p>Every day we eat and drink food to give our body the things we need to grow and stay healthy. Have you ever wondered where all the food goes once you eat it, and how it gets used by the body? In this activity, you will share your ideas in writing and by drawing a model of what happens to food in the body. If we can figure out what happens to food in a healthy person, we can figure out what is different in M'Kenna that makes her sick.</p>
                              </div>


                            </div>

                            <hr className="notebook-icon my-5" />

                            <span className="sr-only">Notebook Icon</span>

                            <h3 className="section-heading bold-me">Set up your notebook with the Focus Question and write and draw your ideas about this question.</h3>

                            <p className="list-heading bold-me underline-me">On your own</p>

                            <ol>
                              <li>Write the Focus Question, <span className="bold-me">What happens to food in a healthy person, and how is it different for M'Kenna?</span> Draw a box around the question. Then write your ideas answering this question.</li>
                              <li>Below your answer, draw another box and title it "How my ideas changed". You will record changes to your answer in this space as you learn more about what happens to food. Leave this space blank right now.</li>
                              <li>On a new page make a detailed drawing of what happens to food inside the body. This detailed drawing is one example of a model that can help you explain how food is changed inside the body. A model represents important parts of a system, how the parts are connected, and the role of each part in the system. Draw, label, and describe as much as you know about where food travels in the body once it is eaten and how the food is changed inside the body.</li>
                            </ol>
                          </div>
                        </div>
                      </TeacherContentStudentAccordion>
                    </Col>
                    <Col xs={12} lg={6} name="teacher-accordion-column">
                      <Container fluid>
                        <Row>
                          <TeacherContentTeacherAccordion title="Time Estimate" open={true}>
                            <p>Estimated time to complete this web page: 10 min</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Before You Teach" open={true}>
                            <ul>
                              <li>Print <a href="https://media.bscs.org/3dmss/se/documents/01_dig/agree_or_disagree_2019.pdf" target="_blank" rel="noopener noreferrer" className="italic">Agree or Disagree&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a> handout (1 per student).</li>
                              <li>Print <a href="https://media.bscs.org/3dmss/se/documents/01_dig/a_trip_through_digestion_2019.pdf" target="_blank" rel="noopener noreferrer" className="italic">A Trip through Digestion&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a> data sheet (1 set of 6 tables per student).</li>
                              <li>Print <a href="https://media.bscs.org/3dmss/se/documents/01_dig/model_tracker_2019.pdf" target="_blank" rel="noopener noreferrer" className="italic">Model Tracker&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a> (1 per student).</li>
                            </ul>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Where are we in the storyline?" open={true}>
                            <p><span className="bold-me">Storyline for Disciplinary Core Ideas (DCIs)</span></p>

                            <p>Students have figured out that the problem is with M'Kenna's digestive system. By the end of this lesson, students narrow it down to a problem with either her small intestine or her large intestine.</p>

                            <p><span className="bold-me">Storyline for Science and Engineering Practices (SEPs)</span></p>

                            <p>Over the course of the unit, students will develop their abilities related to two SEPs: <span className="italic">Developing and Using Models and Engaging in Argument from Evidence</span>. With each lesson, we gradually increase the complexity of the practice. In the Chapter 1 Engage activity, students begin by drawing an initial model to explain their ideas about what happens to food as it moves through the body. Throughout Chapter 1, students will revise this model using evidence as they complete activities.</p>

                            <p>Students also begin to <span className="italic">Engage in Argument from Evidence</span> in the Engage and Explore activities of Chapter 1. In the Engage activity, they read about what the word "claim" means and consider two separate claims. They consider what evidence they might need to argue in favor of one claim over another. In the Explore activity, they use evidence from an interactive to infer the function of each organ in the digestive system.</p>

                            <p><span className="bold-me">Storyline for Crosscutting Concepts (CCCs)</span></p>

                            <p>There are two focal CCCs in the unit: <span className="italic">Patterns and Systems and System Models</span>. In the Engage and Explore activities, students develop a model for the digestive system and immediately begin to consider how the parts of a system work together as a whole. In addition, students use patterns in data to help them understand the function of each organ in the digestive system.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Phenomenon for This Lesson" open={true}>
                            <p>The chemical composition of food changes as it passes through the digestive system, and in the small intestine and large intestine, some of the chemicals and water seem to disappear from the digestive system.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Main Learning Goal" open={true}>
                            <p>The amount and type of food molecules change as they move through the digestive system. In a healthy person, food molecules vanish from the small intestine, but they don't vanish as much in M'Kenna. <span className="italic">Students will meet this Main Learning Goal by the end of the Explore</span>.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Teacher Moves During the Lesson: Steps 1-3" open={true}>
                            <hr style={{margin: '10px 0'}} />

                            <div className="text-center">
                              {/* For multiple icons: Every icon except the last one should have margin-right: 1rem; */}
                              {/* For a single icon, leave margin-right: 1rem; out all together. */}
                              <img src="https://media.bscs.org/3dmss/te/icons/stella-strategy-b-icon.svg" alt="Stella strategy B icon." style={{width: '42px'}} />
                            </div>

                            <hr style={{margin: '10px 0'}} />

                            <div className="col-12">
                              <span className="sr-only">STeLLA strategy B Icon</span>
                              <h3 className="section-heading bold-me my-4 text-center"><a href="https://media.bscs.org/3dmss/te/documents/01_dig/stella_strategies_booklet_2018.pdf#page=45" target="_blank" rel="noopener noreferrer">Set the purpose with a Focus Question&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a></h3>
                            </div>

                            <ol type="A">
                              <li>
                                <p><span className="bold-me">Introduce the Focus Question</span></p>
                                <p>Ask students to indicate in their notebooks that they are at the start of a new activity by writing the title of the new activity and the date. They should also add the information to their table of contents.</p>
                                <p><span className="bold-me">Step 1</span> asks students to write the Focus Question, put a box around it, and write their initial ideas (leaving room to show how their ideas change). This process allows students to surface their initial conceptions and make you, the teacher, aware of them.</p>
                                <p>In <span className="bold-me">step 2</span>, students record how their thinking has changed-making what they learn more impactful. They will better remember what they learn. Students should always return to the Focus Question to update their thinking.</p>
                              </li>
                              <li>
                                <p><span className="bold-me">Students draw initial models of digestion</span></p>

                                <p>Students will draw an initial model in <span className="bold-me">step 3</span> of what they think happens to food in the body. It is important that students try to use their drawings to explain the idea that food looks (and smells) different on the way in compared to on the way out. Students will revisit and revise their models repeatedly over the course of the unit so they can  better use the model to explain body systems phenomena.</p>
                              </li>
                            </ol>

                            <p>As students work on their models, walk around and ask them to label what they are drawing, add detail, and write down any questions they have.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Classroom Videos from This Lesson" open={true}>
                            <hr style={{margin: '10px 0'}} />

                            <div className="text-center">
                              {/* For multiple icons: Every icon except the last one should have margin-right: 1rem; */}
                              {/* For a single icon, leave margin-right: 1rem; out all together. */}
                              <img src="https://media.bscs.org/3dmss/te/icons/video-ant-icon.svg" alt="Video Ant icon." style={{width: '42px', marginRight: '1rem'}} />
                            </div>

                            <hr style={{margin: '10px 0'}} />

                            <div className="col-12">
                              <span className="sr-only">Video Ant Icon</span>
                              <h3 className="section-heading bold-me my-4 text-center">Classroom Videos from This Lesson</h3>
                            </div>

                            <p><span className="bold-me">Video 1 Summary</span></p>

                            <p>This is the beginning of the class and the first Focus Question in the chapter. Students are introduced to the curriculum and begin to think about what happens to food during digestion.</p>

                            <Video vimeo_id="345951252" />

                            <p><a href="https://media.bscs.org/3dmss/te/documents/01_dig/3dmss_pdvid_ch1_1_fq_transcript.pdf" target="_blank" rel="noopener noreferrer">Transcript&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a></p>

                            <p><span className="bold-me">Video 2 Summary</span></p>

                            <p>This is the beginning of the class and the first Focus Question in the chapter. Mr. Ollison uses the Focus Question to elicit students' initial ideas. Students have seen M'Kenna's doctor's note and know of her symptoms.</p>

                            <Video vimeo_id="345950747" />

                            <p><a href="https://media.bscs.org/3dmss/te/documents/01_dig/3dmss_pdvid_ch1_2_fq_e_transcript.pdf" target="_blank" rel="noopener noreferrer">Transcript&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a></p>
                          </TeacherContentTeacherAccordion>
                        </Row>
                      </Container>
                    </Col>
                  </React.Fragment>
                }
                {!this.state.authenticated &&
                  <StudentContent>
                    <div className="row">
                      <div className="col-12">
                        <hr className="focus-question-heading bold-me" />

                        <p className="focus-question bold-me">What happens to food in a healthy person, and how is it different for M'Kenna?</p>

                        <hr className="after-focus-question" />

                        <div className="row">
                          <div className="col-12">
                          <div className="image-wrapper-right">
                          <Img
                            fluid={this.props.data.image1.childImageSharp.fluid}
                            alt="Image of a student with their school lunch on a tray."
                            className="image image-bordered"
                          />
                          <div className="image-caption image-caption-bordered">
                            Lunch is an important meal in the day. Your body depends on getting food during the day, but why?  <br />
                            <span className="image-credit">Courtesy Steve Debenport</span>
                          </div>
                          </div>
                            <p>Every day we eat and drink food to give our body the things we need to grow and stay healthy. Have you ever wondered where all the food goes once you eat it, and how it gets used by the body? In this activity, you will share your ideas in writing and by drawing a model of what happens to food in the body. If we can figure out what happens to food in a healthy person, we can figure out what is different in M'Kenna that makes her sick.</p>
                          </div>


                        </div>

                        <hr className="notebook-icon my-5" />

                        <span className="sr-only">Notebook Icon</span>

                        <h3 className="section-heading bold-me">Set up your notebook with the Focus Question and write and draw your ideas about this question.</h3>

                        <p className="list-heading bold-me underline-me">On your own</p>

                        <ol>
                          <li>Write the Focus Question, <span className="bold-me">What happens to food in a healthy person, and how is it different for M'Kenna?</span> Draw a box around the question. Then write your ideas answering this question.</li>
                          <li>Below your answer, draw another box and title it "How my ideas changed". You will record changes to your answer in this space as you learn more about what happens to food. Leave this space blank right now.</li>
                          <li>On a new page make a detailed drawing of what happens to food inside the body. This detailed drawing is one example of a model that can help you explain how food is changed inside the body. A model represents important parts of a system, how the parts are connected, and the role of each part in the system. Draw, label, and describe as much as you know about where food travels in the body once it is eaten and how the food is changed inside the body.</li>
                        </ol>
                      </div>
                    </div>
                  </StudentContent>
                }
              </Row>
              <NextPreviousRow location={location} authenticated={this.state.authenticated} />
            </Container>
          </Layout>
        </React.Fragment>
      )
    }
  }
}

export default Page

export const query = graphql`
  query {
    image1: file(relativePath: { eq: "01_dig/1388.jpg" }) {
      ...threedmssImage
    }
  }
`
